export const draftEnUSTranslations = {
  draftBannerMessage: "You have unsaved changes from a previous session.",
  draftBannerRestore: "Restore",
  draftBannerDiscard: "Discard",
  clearDraftTooltip: "Clear form",
};
